import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@material-ui/core'

import React, { FC } from 'react'
import { FormProvider, useForm } from 'react-hook-form'

import { ProductFormInterface } from '../../interfaces/product'
import CompanyProductFormMainBody from './CompanyProductFormMainBody'

type Props = {
  createProductHandler: (createdProduct: ProductFormInterface) => void
  handleCloseDialog: () => void
}

const CompanyProductNewForm: FC<Record<string, unknown> & Props> = ({
  createProductHandler,
  handleCloseDialog
}: Props) => {
  const productDetail: ProductFormInterface = {
    categoryId: '',
    name: '',
    hsCode: '',
    brands: '',
    packaging: '',
    category: {
      name: ''
    },
    seasonsAvailable: []
  }
  const methods = useForm<ProductFormInterface>({
    defaultValues: {
      ...productDetail
    }
  })

  const { handleSubmit } = methods

  return (
    <FormProvider {...methods}>
      <form>
        <DialogTitle id="form-dialog-title">New Product</DialogTitle>
        <DialogContent>
          <CompanyProductFormMainBody productDetail={productDetail} />
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            onClick={handleCloseDialog}
            color="default"
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleSubmit(createProductHandler)}
            color="primary"
          >
            Create
          </Button>
        </DialogActions>
      </form>
    </FormProvider>
  )
}

export default CompanyProductNewForm
